export const environment = {
  production: false,
  origin: 'https://dev-itworkflow.set.or.th',
  apiBasePath: 'https://dev-itworkflow.set.or.th/api',
  subServiceJiraApiBasePath: 'https://dev-itworkflow.set.or.th/jira-api',
  oldWorkFlow: 'http://test.workflow.set/itservicerequest/Pages/AdvanceSearch.aspx',
  tenant: '7cf70668-de90-4e0a-bdc1-42dd27fc4aee',
  clientId: 'b4d2b678-81fd-40dc-8fde-3558dd0a2800'
};
